import Translatable from "@/components/translatable_text/Translatable";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Link } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuTrigger,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { LogOut, User, User2Icon } from "lucide-react";
import { Button } from "@/components/ui/button";
import LanguageAction from "@/components/languageAction/LanguageAction";
import { useContext } from "react";
import { AuthContext } from "@/context/authContext";


export default function Navbar() {

  const {logout} = useContext(AuthContext)
  
  return (
    <nav className="w-full h-10 py-6 border-b flex items-center justify-between">
      <div className=" w-full flex gap-4 items-center justify-start">
        <div>
          <SidebarTrigger />
        </div>
        <Link className="text-black" to={"/"}><Translatable>Home</Translatable></Link>
      </div>
      <div className="w-full flex gap-4 justify-end items-center">
        <LanguageAction />
        <DropdownMenu>
          <DropdownMenuTrigger>
            <div className="w-8 h-8 text-black bg-gray-200 rounded-full flex items-center justify-center">
              <User size={16} />
            </div>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-56" align="end">
            <DropdownMenuGroup>
              <DropdownMenuItem className="p-2">
                <Link to='/admin/profile'>
                  <Translatable>
                      Profile
                  </Translatable>
                </Link>
                <User2Icon/>
              </DropdownMenuItem>
              {/* <DropdownMenuSeparator /> */}
              <DropdownMenuItem className="p-2 text-rose-900">
                <Button variant='ghost' onClick={() => logout()}>
                  <Translatable>
                    Logout
                  </Translatable>
                  <LogOut className="text-rose-900"/>
                </Button>
              </DropdownMenuItem>
            </DropdownMenuGroup>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </nav>
  )
}
